import { render, staticRenderFns } from "./SessionExpiresWarning.vue?vue&type=template&id=73806247&scoped=true&"
import script from "./SessionExpiresWarning.vue?vue&type=script&lang=js&"
export * from "./SessionExpiresWarning.vue?vue&type=script&lang=js&"
import style0 from "./SessionExpiresWarning.vue?vue&type=style&index=0&id=73806247&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73806247",
  null
  
)

export default component.exports